import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { Component } from "react";
import { httpGet, httpPost } from "../util/http";
import { MdClose } from "react-icons/md";
import BasicDataGrid from "./BasicDataGrid";
import QtdInput from "./QtdInput";
import ProdAdd from "./ProdAdd";

export default class ManualCount extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            btnLoading: false,
            produtos: [],
            showProdAdd: false
        };
    }

    componentDidMount() {
        this.setState({ loading: true });
        httpGet('/inventarios/' + this.props.inventario?.id + '/manualproducts',
            data => {
                //console.log(data)
                this.setState({
                    produtos: data,
                    loading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
        );
    }

    handleQtdChange(codigo, derivacao, value) {
        console.log(value);
        this.setState((prevState) => ({
            produtos: prevState.produtos.map(produto =>
                produto.codigo === codigo && produto.derivacao === derivacao
                    ? { ...produto, qtd: value }
                    : produto
            )
        }));
    }

    submit() {
        let counts = this.state.produtos.map(produto => ({
            codigo: produto.codigo,
            derivacao: produto.derivacao,
            qtd: produto.qtd,
        }));
        console.log(counts);
        this.setState({ btnLoading: true });
        httpPost('/inventarios/' + this.props.inventario?.id + '/manualproducts', {
            counts
        },
            data => {
                //console.log(data)
                this.setState({
                    btnLoading: false,
                });
                this.props.onClose(true);
            },
            error => {
                console.log(error);
                this.setState({ btnLoading: false });
            },
            false
        );
    }

    onAdd(produto) {
        let produtos = this.state.produtos;
        const hasProduto = produtos.some(
            (p) => p.codigo === produto.codigo && p.derivacao === produto.derivacao
        );

        if (hasProduto) {
            this.setState({ showProdAdd: false })
            return;
        }

        produtos.unshift(produto);
        this.setState({ produtos, showProdAdd: false })
    }

    render() {
        return (
            <Dialog maxWidth="800px" open={true} sx={{ zIndex: 99999 }}>
                <DialogTitle color="primary" fontSize={12}>CONTAGEM MANUAL</DialogTitle>
                <IconButton sx={{ position: 'absolute', right: 8, top: 8 }} onClick={e => this.props.onClose(false)}>
                    <MdClose size={18} />
                </IconButton>
                <DialogContent>
                    {this.state.showProdAdd && <ProdAdd onAdd={produto => this.onAdd(produto)} inventario={this.props.inventario} onClose={() => this.setState({ showProdAdd: false })} />}
                    <Stack mt={-3} mb={3} minWidth="400px">
                        {this.state.loading == true ? (
                            <Stack alignItems="center" mt={2}>
                                <CircularProgress size={50} />
                            </Stack>)
                            :
                            (<Stack>
                                <Typography variant="caption" mb={2}>Por favor, informe manualmente a quantidade dos produtos abaixo. Ou caso não encontre na lista o produto desejado, clique em 'Adicionar produto.'</Typography>
                                <Stack direction="row" gap={1}><Button onClick={() => this.setState({ showProdAdd: true })} size="small" color="success" variant="contained" disableElevation>Adicionar produto</Button></Stack>
                                {(this.state.produtos.length == 0) ? <Typography textAlign="center" mt={1} variant="caption">Nenhum produto para contar</Typography> :
                                    <Table >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell width={40}>Cód.</TableCell>
                                                <TableCell>Nome</TableCell>
                                                <TableCell width={100}>Deriv.</TableCell>
                                                <TableCell width={100}>Cont. ant.</TableCell>
                                                <TableCell width={200}>Quant.</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.produtos.map((produto) => (
                                                <TableRow key={produto.codigo + produto.derivacao}>
                                                    <TableCell>{produto.codigo}</TableCell>
                                                    <TableCell>{produto.descricao}</TableCell>
                                                    <TableCell>{produto.derivacao}</TableCell>
                                                    <TableCell>{produto.ult_qtd}</TableCell>
                                                    <TableCell>
                                                        <QtdInput value={produto.qtd} onChange={value => this.handleQtdChange(produto.codigo, produto.derivacao, value)} />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>}
                            </Stack>)
                        }
                    </Stack>
                </DialogContent>
                <DialogActions>
                    {
                        !this.state.loading ? (this.state.btnLoading ? <CircularProgress size={20} sx={{ mr: 4 }} /> : <Button size="small" color="success" onClick={e => this.submit()}>Finalizar</Button>) : <></>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}